import {TwitterAuthService} from '../../libs/ui/src/index';
import {client} from '../apiService';

const _TwitterAuthService = new TwitterAuthService({client});
export {_TwitterAuthService as TwitterAuthService};
